import {User} from "lucide-react"

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
} from "@/components/ui/sidebar"
import { adminRouts } from "@/l-data/admin/sidebarTabs"
import { AppState, useSelector } from "@/store/Store";
// import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "@/context/authContext";
import Translatable from "../translatable_text/Translatable";
import SidebarItem from "../admin/SidebarItem";


export function AppSidebar() {

  const { currentUser } = useContext(AuthContext)
  const activeDir = (useSelector((state: AppState) => state.customizer.activeDir) === "ltr" ? "left" : "right");

  return (
    <Sidebar 
      style={{
        backgroundImage: `url(/light/assets/imgs/admin/gradiant-bg.webp)`,
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }} 
      variant="sidebar" collapsible={"icon"} side={activeDir}
    >
      <SidebarHeader>
        <div className="flex items-end gap-1">
          <div className="p-1 w-16 h-16 text-black rounded-full flex items-center justify-center">
            <img src="/light/assets/imgs/fox.png" className="w-16 h-16"/>
          </div>
          <div className="group-data-[collapsible=icon]:hidden">
            <span className="text-3xl mb-1 font-medium text-white"><Translatable>GCAD</Translatable></span>
          </div>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu className="p-0">
            {adminRouts.map((item, i) => (
                <div key={i}>
                  <SidebarItem
                    href={item.href}
                    title={item.title}
                    Icon={item.icon}
                  />
                </div>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="border-gray-300 flex flex-row items-center gap-2 justify-start">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8  bg-gray-200 rounded-full flex items-center justify-center">
            <User size={16} />
          </div>
          <div className="group-data-[collapsible=icon]:hidden">
            <div className="flex gap-2 ">
              <span className="text-smx font-medium text-gray-400">{currentUser?.name}</span>
            </div>
          </div>
        </div>
      </SidebarFooter>
    </Sidebar>
  )
}